import React from "react";
import {observer} from "mobx-react";
import {CardBox} from "../../../../basic-components/card/card.box";
import styled from "styled-components";
import {useServices} from "../../../../hooks/use-services.hook";
import {CheckboxComponent} from "../../../../basic-components/checkbox/checkbox.component";

const HoldBookingBox = styled(CardBox)`
    font-size: ${props => props.theme.fontSize.h4};
    font-weight: ${props => props.theme.fontWeight.semiBold};
`

export const HoldBookingComponent: React.FC = observer(() => {
    const services = useServices();
    const booking = services.booking.current;
    if(!booking.allowHold) {
        return null;
    }

    return (
        <HoldBookingBox>
            <CheckboxComponent checked={booking.paymentHandler.holdBooking}
                               label={services.language.translate('Hold booking')}
                               labelPlacement={'end'}
                               onChange={(isChecked) => booking.paymentHandler.holdBooking = isChecked}/>
        </HoldBookingBox>
    )
})